import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { RootState } from './types';

import { article } from './modules/article';
import { calendar } from './modules/calendar';
import { document } from './modules/document';
import { evaluator } from './modules/evaluator';
import { newsletter } from './modules/newsletter';
import { profile } from './modules/profile';
import { proposal } from './modules/proposal';
import { quote } from './modules/quote';
import { role } from './modules/role';
import { salesReport } from './modules/sales-report';
import { sectionAccess } from './modules/section-access';
import { statistic } from './modules/statistic';
import { task } from './modules/task';
import { users } from './modules/users';
import { vacation } from './modules/vacation';
import { work } from './modules/work';

Vue.use(Vuex);

const state: RootState = {
    appLoaded: false,
    permissions: [],
    preferences: [],
    settings: [],
    tenant: undefined,
    user: undefined,
    genericModels: [],
    genericModelRoutes: []
};

const store: StoreOptions<RootState> = {
    state,
    getters,
    mutations,
    actions,
    modules: {
        article,
        calendar,
        document,
        evaluator,
        newsletter,
        profile,
        proposal,
        quote,
        role,
        salesReport,
        sectionAccess,
        statistic,
        task,
        users,
        vacation,
        work
    },
};

export default new Vuex.Store<RootState>(store);
